module.exports = __webpack_public_path__ + "static/media/footer-1.f9349ba2.svg";